import styled from "styled-components";

type MiniProgressProps = {
	completed: number;
	total: number;
};

const Progress = styled.div`
	min-width: 0;
`;

const Track = styled.div`
	height: 8px;
	border-radius: 999px;
	background: #e9edfd;
	overflow: hidden;
`;

const Fill = styled.div<{ $percentage: number; $complete: boolean }>`
	width: ${({ $percentage }) => `${$percentage}%`};
	height: 100%;
	border-radius: inherit;
	background: ${({ $complete }) => ($complete ? "#58b623" : "#fdbb3f")};
`;

const Count = styled.div`
	margin-top: 6px;
	color: #737373;
	font-size: 13px;
	line-height: 18px;
`;

export const MiniProgress = ({ completed, total }: MiniProgressProps) => {
	const safeTotal = Math.max(0, total);
	const safeCompleted = Math.min(Math.max(0, completed), safeTotal);
	const percentage = safeTotal === 0 ? 0 : (safeCompleted / safeTotal) * 100;

	return (
		<Progress aria-label={`${safeCompleted} out of ${safeTotal} deliverables complete`}>
			<Track>
				<Fill $percentage={percentage} $complete={safeTotal > 0 && safeCompleted === safeTotal} />
			</Track>
			<Count>
				{safeCompleted} out of {safeTotal}
			</Count>
		</Progress>
	);
};
